<script lang="ts">
	import Icon from '$lib/elements/Icon.svelte';
	import { t } from 'svelte-i18n';
	import { tooltipAction } from '$lib/actions/tooltip';
	import { capitalize, formatAmountWithCurrency } from '$lib/utils/strings';
	import { page } from '$app/stores';

	export let props;
</script>

<div class="space-y-2">
	<div class="flex items-center space-x-2">
		<div class="text-success flex-shrink-0">
			{#if props.percentageYieldBond}
				<Icon name="yield" size="small" />
			{:else if $page.data.user}
				<Icon name="tax_relief" size="small" />
			{:else}
				<Icon name="euro" size="small" />
			{/if}
		</div>
		<div>
			{#if props.percentageYieldBond}
				<strong>{props.percentageYieldBond} {$t('operation.percentageYieldBond')}</strong>
			{:else if $page.data.user}
				<strong>{capitalize($t('operation.taxReliefShortened'))}</strong>
			{:else}
				<strong>
					<span
						class="tracking-normal"
						use:tooltipAction={{
							title: capitalize($t('operation.amountToSeek'))
						}}
					>
						{formatAmountWithCurrency(props.amountToSeek)}
					</span></strong
				>
			{/if}
		</div>
	</div>
	{#if $page.data.user}
		{#if props.isPaymentTransferPEA}
			<div>{$t('operation.shareSavingsPlan')}</div>
		{/if}
		{#if props.isTaxReliefIRPP}
			<div>
				{$t('operation.incomeTax')}
				{props.rateOfTaxExemptionIRPP ? `${props.rateOfTaxExemptionIRPP}%` : ''}
			</div>
		{/if}
		{#if props.isTaxReliefIntakeDisposal}
			<div>{$t('operation.contributionCession')}</div>
		{/if}
	{/if}
</div>
